import React, { useEffect, useState } from 'react';

const NewsUpdates = () => {
  const [newsData, setNewsData] = useState([]);
  const [fileToView, setFileToView] = useState(null);

  const fetchDataNews = async () => {
    try {
      const response = await fetch(`https://backend.impactjournal.co.in/news`);
      const res = await response.json();
      setNewsData(res.reverse());
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchDataNews();
  }, []);

  const isPDF = (fileUrl) => {
    return fileUrl?.toLowerCase().endsWith('.pdf');
  };

  return (
    <div className="news-container">
      <div className="news-header">
        <h3>News & Updates</h3>
      </div>

      <div
        className="news-scroll"
        onMouseEnter={(e) => e.currentTarget.classList.add('paused')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('paused')}
      >
        <div className="news-track">
          {newsData.concat(newsData).map((news, index) => (
            <div className="news-item" key={index}>
              <div className="news-info">
                <span className="news-date">
                  {new Date(news.date).toLocaleDateString('en-GB')}
                </span>
                <span className="news-title">{news.heading}</span>
                <span className="news-description">{news.description}</span>
              </div>
              {news.file && (
                <button
                  className="news-download"
                  onClick={() => setFileToView(news.file)}
                >
                  View
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {fileToView && (
        <div className="pdf-modal-overlay" onClick={() => setFileToView(null)}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="pdf-close-btn" onClick={() => setFileToView(null)}>
              &times;
            </button>

            {isPDF(fileToView) ? (
              <iframe
                src={`https://backend.impactjournal.co.in/uploads/news/${fileToView}#toolbar=0`}
                title="PDF Viewer"
                className="pdf-frame"
                frameBorder="0"
              ></iframe>
            ) : (
              <img
                src={`https://backend.impactjournal.co.in/uploads/news/${fileToView}`}
                alt="News Media"
                className="pdf-frame"
                style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsUpdates;
